var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconawesomeLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.963,
    height: 18.962,
    viewBox: "0 0 18.963 18.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#094674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05233a"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin",
    "data-name": "Icon awesome-linkedin",
    d: "M17.608,2.25H1.35A1.36,1.36,0,0,0,0,3.617V19.845a1.36,1.36,0,0,0,1.35,1.367H17.608a1.364,1.364,0,0,0,1.354-1.367V3.617A1.364,1.364,0,0,0,17.608,2.25ZM5.731,18.5H2.921V9.454H5.735V18.5ZM4.326,8.218a1.63,1.63,0,1,1,1.63-1.63A1.63,1.63,0,0,1,4.326,8.218ZM16.267,18.5H13.456V14.1c0-1.05-.021-2.4-1.46-2.4-1.465,0-1.689,1.143-1.689,2.324V18.5H7.5V9.454h2.7V10.69h.038a2.96,2.96,0,0,1,2.662-1.46c2.844,0,3.374,1.875,3.374,4.313Z",
    transform: "translate(0 -2.25)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeLinkedin);
export default __webpack_public_path__ + "static/media/Icon awesome-linkedin.24975eab42d0910980d1a7ea509fd0f2.svg";
export { ForwardRef as ReactComponent };